export class SynapiTaxonomy {
    Valeur: number;
    Children: SynapiTaxonomy[]
    id: string;
    name: string;
    show = false;
    ObjectCount: number;
}
